import { get, post } from "app/apis";
import BookingRoutes from "./BookingRoutes";

const GoEasyBookingService = {
  getMoving: async () => {
    const data = await get(BookingRoutes.getMoving);
    return data;
  },
  getCarService: async () => {
    const data = await get(BookingRoutes.getCarService);
    return data;
  },
  assignDriver: async (obj) => {
    const data = await post(BookingRoutes.assignDriver, obj);
    return data;
  },
  deleteMoving: async (obj) => {
    const data = await post(BookingRoutes.deleteMoving, obj);
    return data;
  },
};

export default GoEasyBookingService;
